export default {
  state: {
    panel: false,
    workplace: false,
    filters: false,
    sports: false,
    sports_new: false,
    loader: false,
    party: false,
    invite: false,
    invite_new: false,
    new_chat: false,
    chat_settings: false,
    chat_list: true,
    theme: false
  },
  mutations: {
    setState(state, params) {
      state[params.element] = params.val != undefined ? params.val : !state[params.element];
    },
  },
  actions: {
    changeState({ commit }, params) {
      commit('setState', params);
    },
  },
  getters: {
    panel: (s) => s.panel,
    workplace: (s) => s.workplace,
    filters: (s) => s.filters,
    sports: (s) => s.sports,
    sports_new: (s) => s.sports_new,
    loader: (s) => s.loader,
    party: (s) => s.party,
    invite: (s) => s.invite,
    invite_new: (s) => s.invite_new,
    new_chat: (s) => s.new_chat,
    chat_settings: (s) => s.chat_settings,
    chat_list: (s) => s.chat_list,
    getThemeModal: (s) => s.theme,
  },
};
